module.exports = __webpack_public_path__ + "static/media/instructionHistory.10c7da1e.svg";